import Middleware from '../Middleware';
import { runInAction } from 'mobx';
import { EventTypes } from '../../events';
var logErrorsMiddleware = process.env.NODE_ENV === 'development' ? Middleware(function (evt) {
  if (evt.type === EventTypes.NAVIGATION_ERROR) {
    console.error('[router] Unhandled error caught in router', evt.error);
  }

  return evt;
}) : Middleware.EMPTY;
export default logErrorsMiddleware;